import BaseService from "./BaseService";

// Settings > Enterprise > Company sign-in, and the Test connection result.
export const getSsoSettings = () => BaseService.callAPI("/enterprise/sso");

export const saveSsoSettings = (data) =>
  BaseService.callAPI("/enterprise/sso", "PUT", data);

export const uploadSsoMetadata = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return BaseService.callAPI(
    "/enterprise/sso/metadata",
    "POST",
    { formData },
    {},
    { contentType: "multipart/form-data" }
  );
};

export const startSsoTest = () =>
  BaseService.callAPI("/enterprise/sso/test", "POST", {});

export const removeSso = () => BaseService.callAPI("/enterprise/sso", "DELETE");

export const setRequireMfa = (requireMfa) =>
  BaseService.callAPI("/enterprise/sign-in-settings", "PUT", { requireMfa });

export const getSsoTestResult = (subDomain, code) =>
  BaseService.callAPI(
    `/sso/${encodeURIComponent(subDomain)}/test/${encodeURIComponent(code)}`
  );
